<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2023-10-09 16:05:04
 * @LastEditTime: 2023-11-20 10:56:27
 * @LastEditors: WangYuhan
-->
<template>
  <div v-if="dialogVisible" class="bulletin_board">
    <el-dialog :visible.sync="dialogVisible" width="750px" close-on-click-modal="true">
      <div class="warpper">
        <div class="header">
          <img src="@/assets/images/home/tongzhi.png" alt="" />
        </div>
        <div class="contain">
          <div class="totas">系统升级通知！</div>
          <div class="totas">一、迁移内容</div>
          <div class="totas1">
            <!-- 1、调度小程序从“发货小跟班”迁移到微信小程序“牛运宝调度端”，请调度等角色到新小程序中授权手机号登录。 -->
            微信小程序“牛运宝调度端”迁移到“牛卡福货主”App。
          </div>
          <div class="totas2">
            <!-- 2、司机小程序还是“发货小跟班”改名“牛运宝司机端”，司机师傅可以继续使用。 -->
            微信小程序“牛运宝司机端”迁移到“牛卡福司机”App。
          </div>
          <div class="totas" style="margin-top: 20px">二、迁移时间</div>
          <div class="totas3">2025年6月30日迁移完毕，届时会关停小程序页面，全部切换到App。</div>
          <div class="qcode flex justify_space">
            <div>
              <img src="https://cdn.nucarf.net/nyb/v1.0/images/dispatchapp.png" />
              <span>货主端APP</span>
            </div>
            <div>
              <img src="https://cdn.nucarf.net/nyb/v1.0/images/driverapp.png" />
              <span>司机端APP</span>
            </div>
          </div>
          <div class="button">
            <el-button type="primary" style="width: 180px; height: 38px" @click="handClick">
              知道了
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handClick() {
      this.$emit('handClose');
    },
  },
};
</script>

<style lang="scss">
.bulletin_board .el-dialog__header {
  height: 0 !important;
  padding: 0 !important;
}
.bulletin_board .el-dialog__headerbtn {
  display: none !important;
}
.bulletin_board .el-dialog__body {
  padding: 0 !important;
}
.bulletin_board {
  .warpper {
    height: 630px;
    background: #fff;
    .header {
      height: 100px;
      padding: 0;
      img {
        height: 100px;
      }
    }
    .contain {
      height: 500px;
      padding: 20px 50px 20px;
      .totas {
        height: 26px;
        font-size: 20px;
        font-weight: 500;
        color: #181818;
        line-height: 26px;
        margin-bottom: 16px;
      }
      .totas1,
      .totas2,
      .totas3 {
        height: 30px;
        font-size: 15px;
        font-weight: 400;
        color: #181818;
        line-height: 30px;
      }
      .qcode {
        width: 355px;
        cursor: pointer;
        margin: 24px auto 0;
        div {
          width: 126px;
          height: 126px;
          background: #ffffff;
          border: 1px solid #ebecee;
        }
        div:hover {
          box-shadow: 0px 2px 30px 0px #e4e9ee;
          border: 1px solid #eceef6;
        }
        img {
          width: 103px;
          height: 103px;
          margin: 10px;
        }
        span {
          display: inline-block;
          width: 126px;
          text-align: center;
          margin: 8px 0 50px;
        }
      }
      .button {
        width: 180px;
        margin: 55px auto 0;
      }
    }
  }
}
</style>
